const store = process.env.NODE_ENV === 'development' ?
  require('./configureStoreDev').default :
  require('./configureStoreProd').default

export default store
